import styled from "styled-components";

export const MyInstrumentStyled = styled.div`
  padding: 16px;
  background: ${({ theme }) => theme.COLORS.GRAY_6};
  .title_row_wrap {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title {
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_SEMIBOLD};
    }
  }
  .desc_sec {
    white-space: pre-wrap;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
  }
  .data_wrap {
    padding-left: 16px;
    .data_title {
      margin-bottom: 2px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
      .edit_btn {
        width: 77px;
      }
    }
    .data_desc_list {
      margin-bottom: 20px;
      .data_desc {
        display: flex;
        align-items: center;
        column-gap: 16px;
        .section {
          flex-basis: calc(50% - 8px);
          color: ${({ theme }) => theme.COLORS.BLACK_4};
          font-size: ${({ theme }) => theme.FONT.SIZE.S14};
          font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
        }
        .data {
          flex-basis: calc(50% - 8px);
          color: ${({ theme }) => theme.COLORS.PURPLE_1};
          font-size: ${({ theme }) => theme.FONT.SIZE.S14};
          font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
        }
      }
    }

    .btn_wrap {
      display: flex;
      justify-content: flex-end;
      .btn {
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S16};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
        text-decoration: underline;
        cursor: pointer;
      }
    }
    .line {
      margin: 15px 0;
      border-bottom: 1px solid ${({ theme }) => theme.COLORS.PURPLE_1};
    }
  }
  .btn_add_wrap {
    margin: auto;
    margin-top: 20px;
    width: 210px;
  }

  .theme_standard {
  }
`;
